import { defineStore } from 'pinia'
const axios = require('axios');

export const useAnnouncementsStore = defineStore('announcements', {
    state: () => {
        return {
            announcements: {},
        }
    },

    actions: {
        async get(target) {
            if(target in this.announcements === false) {
                const response = await axios.get(`/api/announcements/${target}`);
                this.announcements[target] = response.data.data;
            }

            return this.announcements[target];
        },
    }
})
